import { cn } from "@/lib/utils";

const ORDER_MAP = {
  "Received": "bg-[hsl(var(--muted))] text-foreground border-border",
  "Confirmed": "bg-[hsl(var(--soft-blush))] text-foreground border-[hsl(var(--soft-blush-dark))]",
  "In Production": "bg-[hsl(var(--soft-blush))] text-foreground border-[hsl(var(--soft-blush-dark))]",
  "Quality Check": "bg-[hsl(60_30%_88%)] text-foreground border-[hsl(60_20%_78%)]",
  "Ready": "bg-[hsl(var(--muted-green))]/25 text-[hsl(var(--muted-green-dark))] border-[hsl(var(--muted-green))]/50",
  "Out for Delivery": "bg-[hsl(var(--muted-green))] text-white border-[hsl(var(--muted-green-dark))]",
  "Delivered": "bg-foreground text-background border-foreground",
};

const QUOTE_MAP = {
  Draft: "bg-[hsl(var(--muted))] text-foreground border-border",
  Pending: "bg-[hsl(var(--soft-blush))] text-foreground border-[hsl(var(--soft-blush-dark))]",
  Approved: "bg-[hsl(var(--muted-green))]/25 text-[hsl(var(--muted-green-dark))] border-[hsl(var(--muted-green))]/50",
  Declined: "bg-[hsl(var(--destructive))]/15 text-[hsl(var(--destructive))] border-[hsl(var(--destructive))]/40",
  Converted: "bg-foreground text-background border-foreground",
};

export default function StatusBadge({ status, kind = "order", className }) {
  const map = kind === "quotation" ? QUOTE_MAP : ORDER_MAP;
  const cls = map[status] || "bg-muted text-foreground border-border";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px] font-sans font-semibold tracking-[0.06em] uppercase border rounded-sm",
        cls,
        className
      )}
      data-testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <span className="inline-block h-1 w-1 rounded-full bg-current opacity-80" />
      {status}
    </span>
  );
}
